<template>
  <div class="container">
    <div class="content">
      <h2> 💳 The Swiping Game: Your Relationship with Plastic Pals 💳 </h2>
      <p><br>Hey there, you modern maven of finance! Let's talk about something we all love and loathe: credit cards. You know, those magical pieces of plastic that make things appear with just a swipe or a tap? 🌈</p>

      <div class="option" @click="selectOption('maxed-out')" :class="{ selected: isSelected('maxed-out') }">
        <span class="icon"> 🛒 </span>
        <b> Swiper's Delight</b>
       <br> The Deal: Using your card for daily expenses, online shopping, and hey, maybe even some impulse buys.
Smart Money Says: Think of this as the "paws-free" option in life. Convenient, quick, and often comes with perks like rewards or cashback.
      </div>

      <div class="option" @click="selectOption('some-debt')" :class="{ selected: isSelected('some-debt') }">
        <span class="icon">🕒</span>
        
        <b>The Pay-Back Purr-iod </b>  <br>The Deal: The time comes to settle the tab. You've got options—pay off the full balance, make the minimum payment, or something in between.
Smart Money Says: This is where the rubber meets the road—or where the cat meets the scratching post. Paying off the full balance? You're a sleek, debt-free panther. Carrying a balance? You're playing a longer game, but be aware of the interest.
      </div>

      <div class="option" @click="selectOption('zero')" :class="{ selected: isSelected('zero') }">
        <span class="icon">📈</span>
        <b>The Interest Intrigue</b><br>
        The Deal: The time comes to settle the tab. You've got options—pay off the full balance, make the minimum payment, or something in between.
Smart Money Says: This is where the rubber meets the road—or where the cat meets the scratching post. Paying off the full balance? You're a sleek, debt-free panther. Carrying a balance? You're playing a longer game, but be aware of the interest.
      </div>
    
    </div>
  </div><br><br><br><br><br><br>
</template>


<script>
import { onboardingStore } from '@/components/stores/onboardingStore'; // Adjust the path as necessary

export default {
  setup() {
    const store = onboardingStore();

    const selectOption = (option) => {
      // Set the selected option directly
      store.updateFormData({ credit: option });
    };

    // Helper method to check if an option is selected
    const isSelected = (option) => store.formData.credit === option;

    return { store, selectOption, isSelected };
  },
};
</script>





<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>